import React from "react";
import { useNavigate } from "react-router-dom";







function FormSupplierProfile({ company }) {
  const navigate = useNavigate();

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <div className="bg-white rounded-2xl shadow-lg p-6 max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">👤 Perfil da Empresa</h1>

        <div className="space-y-3">
          <p><strong>Nome:</strong> {company?.nome}</p>
          <p><strong>Localização:</strong> {company?.localidade}</p>
          <p><strong>IBAN:</strong> {company?.iban}</p>
          <p><strong>Telefone:</strong> {company?.whatsapp}</p>
          <p><strong>Gerente:</strong> {company?.nomegerente}</p>
          <p><strong>NIF:</strong> {company?.nif}</p>
          <p><strong>Tipo de Negócio:</strong> {company?.tipoNegocio}</p>
        </div>

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate("/MNGMT/Profile/Update/")}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            Editar
          </button>

          <button
            onClick={() => navigate(-1)}
            className="bg-gray-300 px-4 py-2 rounded-lg hover:bg-gray-400"
          >
            Regressar
          </button>
        </div>
      </div>
    </div>
  );
}

export default FormSupplierProfile;